var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsStepFunctions32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-Step-Functions_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0084D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F8B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-Step-Functions_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Application-Integration",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23,22 L33,22 L33,18 L23,18 L23,22 Z M33.5,17 L22.5,17 C22.224,17 22,17.224 22,17.5 L22,22.5 C22,22.776 22.224,23 22.5,23 L33.5,23 C33.776,23 34,22.776 34,22.5 L34,17.5 C34,17.224 33.776,17 33.5,17 L33.5,17 Z M22,31.5 C22,32.327 21.327,33 20.5,33 C19.673,33 19,32.327 19,31.5 C19,30.673 19.673,30 20.5,30 C21.327,30 22,30.673 22,31.5 L22,31.5 Z M7,24 L16,24 L16,22 L7,22 L7,24 Z M7,18 L7,16 L11,16 L12,16 L16,16 L16,18 L7,18 Z M19,8.5 C19,7.673 19.673,7 20.5,7 C21.327,7 22,7.673 22,8.5 C22,9.327 21.327,10 20.5,10 C19.673,10 19,9.327 19,8.5 L19,8.5 Z M28,27 L12,27 L12,25 L16.5,25 C16.776,25 17,24.776 17,24.5 L17,21.5 C17,21.224 16.776,21 16.5,21 L12,21 L12,19 L16.5,19 C16.776,19 17,18.776 17,18.5 L17,15.5 C17,15.224 16.776,15 16.5,15 L12,15 L12,13 L28,13 L28,15 L29,15 L29,12.5 C29,12.224 28.776,12 28.5,12 L21,12 L21,10.949 C22.14,10.717 23,9.707 23,8.5 C23,7.122 21.879,6 20.5,6 C19.121,6 18,7.122 18,8.5 C18,9.707 18.86,10.717 20,10.949 L20,12 L11.5,12 C11.224,12 11,12.224 11,12.5 L11,15 L6.5,15 C6.224,15 6,15.224 6,15.5 L6,18.5 C6,18.776 6.224,19 6.5,19 L11,19 L11,21 L6.5,21 C6.224,21 6,21.224 6,21.5 L6,24.5 C6,24.776 6.224,25 6.5,25 L11,25 L11,27.5 C11,27.776 11.224,28 11.5,28 L20,28 L20,29.051 C18.86,29.283 18,30.293 18,31.5 C18,32.878 19.121,34 20.5,34 C21.879,34 23,32.878 23,31.5 C23,30.293 22.14,29.283 21,29.051 L21,28 L28.5,28 C28.776,28 29,27.776 29,27.5 L29,25 L28,25 L28,27 Z",
    id: "AWS_Step_Functions_Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsStepFunctions32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Step-Functions_32.ec2987ebdceb61a4c527d0fd271809af.svg";
export { ForwardRef as ReactComponent };